import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';

const DEFAULT_RATIO = 1 / 1;
class AspectRatioComponent {
    constructor() {
        this.ratio = DEFAULT_RATIO;
    }
    get display() {
        return 'block';
    }
    get position() {
        return 'relative';
    }
    get width() {
        return '100%';
    }
    get paddingBottom() {
        return `${100 / (this.ratio ?? DEFAULT_RATIO)}%`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: AspectRatioComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.1.4", type: AspectRatioComponent, selector: "div[hy-aspect-ratio], hy-aspect-ratio", inputs: { ratio: "ratio" }, host: { properties: { "style.display": "this.display", "style.position": "this.position", "style.width": "this.width", "style.padding-bottom": "this.paddingBottom" } }, ngImport: i0, template: `
    <div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0;">
      <ng-content></ng-content>
    </div>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: AspectRatioComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'div[hy-aspect-ratio], hy-aspect-ratio',
                    template: `
    <div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0;">
      <ng-content></ng-content>
    </div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { ratio: [{
                type: Input
            }], display: [{
                type: HostBinding,
                args: ['style.display']
            }], position: [{
                type: HostBinding,
                args: ['style.position']
            }], width: [{
                type: HostBinding,
                args: ['style.width']
            }], paddingBottom: [{
                type: HostBinding,
                args: ['style.padding-bottom']
            }] } });
const DIRECTIVES = [AspectRatioComponent];
class AspectRatioModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: AspectRatioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: AspectRatioModule, declarations: [AspectRatioComponent], exports: [AspectRatioComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: AspectRatioModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: AspectRatioModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: DIRECTIVES,
                    exports: DIRECTIVES,
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AspectRatioComponent, AspectRatioModule };
